import info from "../../../assets/info-circle.png";
import arrowDown from "../../../assets/arrow-down.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";
import DropDown from "./DropDown";

const Card = ({ headerText, amount, dropdown, height }) => {
  return (
    <div
      className={`relative font-Inter w-full md:w-[225px] xl:w-[310px] ${height} p-[16.27px] bg-white rounded-[10px] border-[0.5px] border-[#DEE2F3]`}
    >
      <div className="flex justify-between">
        <h4 className="font-medium text-base text-sidenavInactive h-[22px]">
          {headerText}
        </h4>
        <img src={info} alt="info" className="h-[22px]" />
      </div>
      <div className="flex items-center">
        <FontAwesomeIcon icon={faNairaSign} className="text-[21px]" />
        <p className="font-medium text-2xl text-[#262F59]">{amount}</p>
      </div>
      {dropdown && (
        <DropDown
          additionalClass="absolute bottom-[16.27px] h-[44px]"
          icon={[<img key={Math.random()} src={arrowDown} alt="arrow down" />]}
          innerText="This Week"
        />
      )}
    </div>
  );
};

export default Card;
